import React from 'react';
import ReactMarkdown from 'react-markdown';
import CoachAvatar from './CoachAvatar';
import { COPY } from './copy';

// Splits the greeting into the heading and the paragraphs under it. The
// persona separates paragraphs with a blank line and puts the heading
// first; a greeting without breaks (older conversations, tenant overrides)
// uses its first sentence as the heading.
export function introParts(content = '') {
  const paragraphs = content.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  if (paragraphs.length > 1) return { heading: paragraphs[0], paragraphs: paragraphs.slice(1) };

  const match = content.trim().match(/^(.+?[.!?])\s+([\s\S]+)$/);
  return match ? { heading: match[1], paragraphs: [match[2]] } : { heading: content.trim(), paragraphs: [] };
}

// The coach's greeting as the conversation's opening (design D01): large
// monogram, "<coach> · Your <role>" eyebrow, serif heading, then the body.
export default function CoachIntro({ coachName, coachRole, content }) {
  const { heading, paragraphs } = introParts(content);
  return (
    <div className="flex flex-col gap-[22px] pt-2" data-testid="coach-intro">
      <CoachAvatar name={coachName} size="lg" />
      <div className="flex flex-col gap-2.5">
        <div className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
          <span className="w-1.5 h-1.5 rounded-full bg-succeedo-orange shadow-[0_0_8px_hsl(var(--succeedo-orange)/0.6)]" />
          {COPY.introEyebrow(coachName, coachRole)}
        </div>
        <h1 className="m-0 font-display font-light text-[32px] md:text-[42px] leading-[1.15] tracking-[-0.02em] text-foreground [text-wrap:balance]">
          {heading}
        </h1>
      </div>
      <div className="flex flex-col gap-3.5 max-w-[640px]">
        {paragraphs.map((p) => (
          <ReactMarkdown
            key={p}
            components={{
              p: ({ node, ...props }) => (
                <p {...props} className="m-0 text-[17px] leading-[1.65] text-foreground/90 [text-wrap:pretty]" />
              ),
              em: ({ node, ...props }) => (
                <em {...props} className="font-display font-light text-[1.12em] text-foreground" />
              ),
            }}
          >
            {p}
          </ReactMarkdown>
        ))}
      </div>
    </div>
  );
}
